var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{style:({ height: _setup.deviceHeight })},[_c('Empty',{attrs:{"text":_vm.$t('enterprise.404-error')}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }